const trackGa = (
	widgetId,
	element,
	result,
	dataToExcludeFromWidgetUserEvent
) => {
	const isBrowser = typeof window !== 'undefined';
	if (isBrowser) {
		const DDC = window.DDC || {};
		const trackingData = {
			event: 'widgetUserEvent',
			widgetName: 'ws-dealer-reviews',
			widgetId,
			element,
			action: 'clicked',
			result,
			dataToExcludeFromWidgetUserEvent
		};

		if (DDC.fireTrackingEvent) {
			DDC.fireTrackingEvent(trackingData);
		}
	}
};

export default trackGa;
